import { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import {
  Button,
  Col,
  Form,
  Row,
  Table,
} from "antd";
import DynamicFormCase from "../DynamicFieldRenderer/DynamicFieldRenderer";
import "../../Components/DynamicForm/DynamicForm.css";
import React from "react";

const FormFieldSetComponent = ({
  fields = [],
  form: any = {},
  handleFieldSetButtonClick = (action: string, fieldSetKey: string, formValue: any, targetIndex?: number) => {},
  dataSource = [],
  fieldSetKey = "",
}) => {
  const [form] = Form.useForm();
  const [gridColumns, setGridColumns] = useState<any[]>([]);
  const [isTempEdit, setTempIsEdit] = useState(false);
  const [targetIndex, setTargetIndex] = useState<number>();
  const [tableData, setTableData] = useState<any[]>([]);

  useEffect(() => {
    let columns: React.SetStateAction<any[]> = [];

    fields?.forEach((sf: { [x: string]: any; parentId: number }) => {
      columns.push({
        key: sf.name,
        dataIndex: sf.name,
        title: sf.label,
        type: sf.type,
        fieldOptions: sf.fieldOptions,
      });
    });

    columns.push({
      key: "gridaction",
      dataIndex: "gridaction",
      title: "Action",
      render: (_text: any, record: any) => (
        <Button type="primary" onClick={() => handleEdit(record)}>
          Edit
        </Button>
      ),
    });
    setGridColumns(columns);
  }, []);

  useEffect(() => {
    if (dataSource && dataSource.length > 0) {
      let tempTableData = dataSource;

      gridColumns?.forEach((x) => {
        if (
          x.type === "selectMulti" &&
          tempTableData &&
          Array.isArray(tempTableData)
        ) {
          let value: string;
          tempTableData?.map((dt) => {
            // Ensure dt is an object and find the first array inside it
            const arrayToMap = Object.values(dt).find((value) =>
              Array.isArray(value)
            ) as any[] | undefined;

            value = arrayToMap
              ? arrayToMap
                  .map((y) => {
                    const found = x.fieldOptions?.find(
                      (opt: { value: string }) => opt.value === y
                    );

                    return found?.label || null;
                  })
                  .filter(Boolean) // Removes null/undefined values
                  .join(", ")
              : dt[x.key]
              ? dt[x.key]
              : "";

            (dt as Record<string, any>)[x.key] = value;
          });

        }
      });
      setTableData(tempTableData);
    }
  }, [dataSource]);

  const handleCancel = () => {
    form.resetFields();
    setTempIsEdit(false);
  };

  // callback method to parent component to update the grid data.
  const handleAddUpdateRow = async (action: boolean) => {
   // await form.validateFields();
    let formValue = { ...form.getFieldsValue(), CreatedBy: 1 };
    if (!action) {
      handleFieldSetButtonClick("Add", fieldSetKey, formValue, -1);
    } else {
      handleFieldSetButtonClick("Update", fieldSetKey, formValue, targetIndex);
      setTempIsEdit(false);
    }
    form.resetFields();
  };

  const handleEdit = (record: any) => {
    setTargetIndex(record.key);
    setTempIsEdit(true);

    let tableRecord = { ...record };

    fields?.forEach((x) => {
      if (x.type === "selectMulti" && tableRecord) {
        // Ensure dt is an object and has the key
        if (!tableRecord || typeof tableRecord !== "object" || !(x.name in tableRecord))
          return;

        let labelsString = "";            
        labelsString = tableRecord[x.name]; // Get the comma-separated string

        if (typeof labelsString === "string") {
          // Convert back from labels to values
          const valuesArray = labelsString
            ?.split(", ") // Split the string into an array of labels
            .map((label: string) => {
              const found = x.fieldOptions?.find(
                (opt: { label: string }) => opt.label === label
              );
              return found?.value || null; // Get the corresponding value or null
            })
            .filter(Boolean); // Remove null values

          (tableRecord as Record<string, any>)[x.name] = valuesArray; // Set the array back
        }
      }
    });

    form.setFieldsValue(tableRecord);
    
  };

  return (
    <>
      <Form form={form} layout="vertical">
        <>
          <Row gutter={[16, 16]}>
            {fields.map((field: any) => (
              <>
                {field.parentId != 0 && (
                  <DynamicFormCase
                    fields={[]}
                    field={field}
                    form={form}
                    keyIdentity={""}
                    actionType={actionType}
                    dataSource={[]}
                    colsize={undefined} section={undefined}                  />
                )}
              </>
            ))}

            <Col lg={24}>
              <div className="button-area">
                <Col span={24}>
                  <div
                    className="button-section"
                    style={{ textAlign: "center", marginTop: "20px" }}
                  >
                    <Button
                      className="btn-cancel"
                      onClick={handleCancel}
                      style={{ marginBottom: 16 }}
                    >
                      Cancel
                    </Button>
                    <Button
                      className="updateBtn"
                      onClick={() => handleAddUpdateRow(isTempEdit)}
                      style={{ marginBottom: 16 }}
                    >
                      {isTempEdit ? "Update" : "Add"}
                    </Button>
                  </div>
                </Col>{" "}
              </div>
            </Col>

            <Col lg={24}>
              <Table
                scroll={{ x: "max-content" }}
                bordered
                dataSource={tableData}
                columns={gridColumns}
                rowClassName="editable-row"
                style={{ width: "100%", marginTop: "40px" }}
                onChange={() => {}}
                // pagination={{
                //   onChange: cancel,
                //   position: [isAddRowTable ? "none" : "bottomRight"],
                // }}
                // {...rest}
              />
            </Col>
          </Row>
        </>
      </Form>
    </>
  );
};

export default FormFieldSetComponent;
